import { ADMIN_LIST_FETCHING, ADMIN_LIST_FAILED, ADMIN_LIST_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ADMIN_LIST_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ADMIN_LIST_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ADMIN_LIST_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
